import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { emailValRegex, formatPhoneNumber, phoneValRegex } from '../../../utils/helpers'
import styles from './LoginHome.module.scss'

const isFirstTimeOnLogin = !localStorage.getItem('visitedDashboard')

const LoginHome = ({ phoneCheckStatus, handleSubmitPhone, handleSubmitEmail }) => {
  useEffect(() => {
    if (!localStorage.getItem('visitedDashboard')) {
      localStorage.setItem('visitedDashboard', 'true')
    }
  }, [])

  const [phoneNumber, setPhoneNumber] = useState()
  const [email, setEmail] = useState()
  const [type, setType] = useState('email')
  const [inputValue, setInputValue] = useState('')

  const socketConnected = useSelector(s => s.socket.connected)

  const loginStep = useSelector(s => s.signIn.loginStep)

  function getValidationPattern(type) {
    if (type === 'phone') {
      return phoneValRegex
    }

    if (type === 'email') {
      return emailValRegex
    }

    return ''
  }

  function handleInputChange(e) {
    const val = e.target.value

    if (type === 'phone') {
      handlePhone(val)
    } else {
      handleEmail(val)
    }
  }

  function handlePhone(phone) {
    setType('phone')
    setPhoneNumber(phone)
    setInputValue(formatPhoneNumber(phone))
  }

  function handleEmail(email) {
    setType('email')
    setEmail(email.trim())
    setInputValue(email.trim())
  }

  function handleSubmitForm(e) {
    e.preventDefault()
    type === 'phone' ? handleSubmitPhone(phoneNumber) : handleSubmitEmail(email)
  }

  function toggleType() {
    setType(type === 'email' ? 'phone' : 'email')
    setInputValue('')
  }

  useEffect(() => {
    const lastLoginType = localStorage.getItem('lastLoginType')
    const lastLoginEmail = localStorage.getItem('lastLoginEmail')
    const lastLoginPhone = localStorage.getItem('lastLoginPhone')

    if (lastLoginType === 'email' && lastLoginEmail) {
      handleEmail(lastLoginEmail)
    }

    if (lastLoginType === 'phone' && lastLoginPhone) {
      handlePhone(lastLoginPhone)
    }
  }, [])

  return (
    <>
      <div>
        <div className="login-content">
          <div className="swpm-login-phone__container">
            <div className="swpm-login-phone__info">
              <h1>Welcome {isFirstTimeOnLogin ? 'to the dashboard' : 'back'}</h1>
              <p>Please sign in to continue to dashboard</p>
            </div>
          </div>
          <div className="swpm-login-phone__phone">
            <form className="swpm-login__phone-form" onSubmit={handleSubmitForm}>
              <TextInput
                className={styles.input}
                type={type === 'email' ? 'email' : 'tel'}
                label={
                  type === 'email'
                    ? 'Enter your email address'
                    : 'Enter your phone number'
                }
                value={inputValue}
                onChange={handleInputChange}
                autoFocus={true}
                pattern={getValidationPattern(type)}
                placeholder={type === 'email' ? 'john@hotel.com' : '(555) 555-5555'}
                disabled={loginStep !== 'loginForm'}
                required
              />
              <button
                id="swpmdl-phone-submit-button"
                className={styles.loginButton}
                disabled={loginStep !== 'loginForm'}
              >
                Log in to the Dashboard
              </button>
            </form>
            {(loginStep === 'pendingSendRequest' ||
              loginStep === 'sentRequestAndOpenedSocket' ||
              (loginStep === 'pendingRequest' && !socketConnected)) && (
              <div className="swpm-phoneval-loader">
                {phoneCheckStatus === 'success' && (
                  <div className="swpm-phoneval-loader__check"></div>
                )}
                <div className="swpm-phoneval-loader__bar"></div>
              </div>
            )}
          </div>
          <button
            className={styles.outsideLink}
            onClick={toggleType}
            disabled={loginStep !== 'loginForm'}
          >
            Login with {type === 'email' ? 'phone number' : 'email'}
          </button>
        </div>
      </div>
    </>
  )
}

export default LoginHome
